import React, { useState } from "react"
import { Box, Flex } from "@theme-ui/components"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { InboundLink } from "./link"
import ChevronUpIcon from "../images/Arrow_Up-blue.inline.svg"
import { useResponsiveValue, useBreakpointIndex } from "@theme-ui/match-media"

const LanguageSwitcher = ({ mobile = false }) => {
  const [show, setShow] = useState(false)
  const mediaIndex = useBreakpointIndex()

  const languagesCountry = {
    it: { code: "it", language: "Italiano" },
    en: { code: "en", language: "English" },
    "zh-cn": { code: "cn", language: "Chinese" },
    "en-us": { code: "en-us", language: "English (United States)" },
    "en-ca": { code: "en-ca", language: "English (Canada)" },
    fr: { code: "fr", language: "Français" },
    de: { code: "de", language: "Deutsch" },
    es: { code: "es", language: "Español" },
    pt: { code: "pt", language: "Português" },
    pl: { code: "pl", language: "Polski" },
    ru: { code: "ru", language: "Русский" },
  }

  return (
    <LanguageSwitcherContext.Consumer>
      {({ activeLocale, paths }) => {
        const activeLink = paths.find(x => x.locale === activeLocale)
        return (
          <Box
            as={"ul"}
            sx={{
              pl: [0],
              py: [2],
              px:[1],
              pb: [3],
              display: "flex",
              overflow: "hidden",
              position: "relative",
              right: 0,
              margin: 0,
              listStyle: "none",
              fontSize: [2],
            }}
          >
            {paths.map((link, index) => (
              <Box as="li" key={index}>
                <InboundLink
                  to={link.value}
                  sx={{
                    whiteSpace: "nowrap",
                    textTransform: "uppercase",
                    color: activeLocale === link.locale ? "light" : "dark",
                    position: "relative",
                    textTransform: "uppercase",
                    fontSize: [3],
                    textDecoration: "none",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Box
                      sx={{
                        mr: [2],
                      }}
                    />
                    {languagesCountry[link.locale.toLowerCase()].code ||
                      link.locale}
                  </Box>
                </InboundLink>
              </Box>
            ))}
          </Box>
        )
      }}
    </LanguageSwitcherContext.Consumer>
  )
}

export default LanguageSwitcher
